import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";

@Component({
    selector: 'app-app-for-region-bar-chart',
    templateUrl: './app-for-region-bar-chart.component.html',
    styleUrls: ['./app-for-region-bar-chart.component.scss']
})
export class AppForRegionBarChartComponent implements OnInit {

    private _appForRegion: any;

    get appForRegion() {
        return this._appForRegion;
    }

    @Input() set appForRegion(val: any) {
        this._appForRegion = val;
        if (val) {
            this.chartAppForRegion = {
                series: [
                    {
                        name: "Application per TRL",
                        data: this._appForRegion.dayData.series
                    },
                ],
                chart: {
                    type: "bar",
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    width: '100%',
                    height: '100%',
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: false
                    }
                },
                colors : ['rgb(141, 119, 231)'],
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: "bottom",
                                offsetX: -10,
                                offsetY: 0
                            }
                        }
                    }
                ],
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                },
                xaxis: {
                    type: "category",
                    categories: this._appForRegion.dayData.labels
                },
                dataLabels: {
                    enabled: true,
                    // formatter: function(val) {
                    //     return val + "%";
                    // },
                    // offsetY: -20,
                    style: {
                        fontSize: "14px",
                        // colors: ["#304758"]
                    }
                },
                legend: {
                    position: "right",
                    // offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };

        }
    }

    chartAppForRegion: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {
    }

}
